import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AnalyticsComponent } from './components/pages/dashboard/analytics/analytics.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard/dashboard.component';
import { EcommerceComponent } from './components/pages/dashboard/ecommerce/ecommerce.component';
import { LoginComponent } from './components/pages/authentication/login/login.component';
import { RegisterComponent } from './components/pages/authentication/register/register.component';
import { ForgotPasswordComponent } from './components/pages/authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/pages/authentication/reset-password/reset-password.component';
import { ReferenceDetailsComponent } from './master/reference-details/reference-details.component';
import { ReferencMasterComponent } from './master/referenc-master/referenc-master.component';
import { ItemMasterComponent } from './master/item-master/item-master.component';
import { AddBankComponent } from './master/add-bank/add-bank.component';
import { BankDetailsComponent } from './master/bank-details/bank-details.component';
import { AddItemComponent } from './master/add-item/add-item.component';
import { CustomersComponent } from './master/customers/customers.component';
import { CustomerDetailsComponent } from './master/customer-details/customer-details.component';
import { OrderEntryComponent } from './order-entry/order-entry.component';
import { BannerUploadComponent } from './banner-upload/banner-upload.component';
import { CategoryImageComponent } from './category-image/category-image.component';
import { DocumentUploadDetailsComponent } from './document-upload-details/document-upload-details.component';
import { SearchCustomerComponent } from './search-customer/search-customer.component';
import { SalesEntryComponent } from './sales-entry/sales-entry.component';
import { SalesDetailsComponent } from './transaction/sales-details/sales-details.component';
import { ViewOrderDetailsComponent } from './view-order-details/view-order-details.component';
import { UpdateCategoryComponent } from './update-category/update-category.component';
import { AuthenticationComponent } from './components/pages/authentication/authentication/authentication.component';
import { AddProduct1Component } from './add-product1/add-product1.component';
import { NotificatonComponent } from './notificaton/notificaton.component';
import { AddItem1Component } from './master/add-item1/add-item1.component';
import { SettingDashboardComponent } from './setting-dashboard/setting-dashboard.component';
import { CutomerSearchComponent } from './cutomer-search/cutomer-search.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { DeletedItemDetailsComponent } from './reports/deleted-item-details/deleted-item-details.component';
import { SalesDashboardComponent } from './sales-dashboard/sales-dashboard.component';
import { B2CReportComponent } from './report/GST-Report/b2-c-report/b2-c-report.component';
import { BillwiseProfitComponent } from './report/Profit-Report/billwise-profit/billwise-profit.component';
import { ItemwiseProfitComponent } from './report/Profit-Report/itemwise-profit/itemwise-profit.component';
import { CustomerwiseProfitComponent } from './report/Profit-Report/customerwise-profit/customerwise-profit.component';
import { OverAllProfitComponent } from './report/Profit-Report/over-all-profit/over-all-profit.component';
import { SalesDashboardTwoComponent } from './sales-dashboard-two/sales-dashboard-two.component';
import { ViewOrderDetails1Component } from './view-order-details1/view-order-details1.component';
import { InvalidLicenceComponent } from './invalid-licence/invalid-licence.component';
import { UserwiseSalesComponent } from './report/userwise-sales/userwise-sales.component';
import { DefaultDashboardComponent } from './default-dashboard/default-dashboard.component';
import { SalesVsRMComponent } from './report/sales-vs-rm/sales-vs-rm.component';
import { ItemwiseSalesVsRMComponent } from './report/itemwise-sales-vs-rm/itemwise-sales-vs-rm.component';
import { SaleswiseProfitComponent } from './saleswise-profit/saleswise-profit.component';
import { AnalysisComponent } from './analysis/analysis.component';
import { Analysis1Component } from './analysis1/analysis1.component';
import { Analysis2Component } from './analysis2/analysis2.component';
import { ReferenceGroupComponent } from './reference-group/reference-group.component';
import { AddReferenceGroupComponent } from './add-reference-group/add-reference-group.component';



const routes: Routes = [
  { path: 'reference-group', component: ReferenceGroupComponent },
  { path: 'add-reference-group', component: AddReferenceGroupComponent },
  { path: 'invalid-licence', component: InvalidLicenceComponent },
  { path: 'default-dashboard', component: DefaultDashboardComponent },
  { path: 'user-wise', component: UserwiseSalesComponent },
  { path: 'analysis', component: AnalysisComponent },
  { path: 'analysis1', component: Analysis1Component },
  { path: 'analysis2', component: Analysis2Component },

  { path: 'add-items1', component: AddItem1Component },
  { path: 'cutomer-search', component: CutomerSearchComponent },

  { path: 'reference', component: ReferenceDetailsComponent },
  { path: 'add-reference', component: ReferencMasterComponent },

  { path: 'add-items', component: AddItemComponent },
  { path: 'item-details', component: ItemMasterComponent },

  { path: 'add-bank', component: AddBankComponent },
  { path: 'bank-details', component: BankDetailsComponent },

  { path: 'add-customer', component: CustomersComponent },
  { path: 'customer-details', component: CustomerDetailsComponent },
  { path: 'setting-dashboard', component: SettingDashboardComponent },
  { path: 'change-password', component: ChangePasswordComponent },



  { path: 'view-order-details1', component: ViewOrderDetails1Component },

  { path: 'view-order-details', component: ViewOrderDetailsComponent },
  { path: 'order-entry', component: OrderEntryComponent },

  { path: 'banner-upload', component: BannerUploadComponent },

  { path: 'document-upload-details', component: DocumentUploadDetailsComponent },

  { path: 'category-image', component: CategoryImageComponent },

  { path: 'update-category', component: UpdateCategoryComponent },
  { path: 'user-profile', component: UserProfileComponent },
  
  { path: 'search_customer', component: SearchCustomerComponent },
  { path: 'add-product1', component: AddProduct1Component },
  { path: 'sales-entry', component: SalesEntryComponent },
  { path: 'sales-details', component: SalesDetailsComponent },
  { path: 'sales-dashboard-two', component: SalesDashboardTwoComponent },

  { path: 'notification', component: NotificatonComponent },
 
  { path: 'deleted-item-details', component: DeletedItemDetailsComponent },
  { path: 'sales-dashboard', component: SalesDashboardComponent },
//gst-report
{ path: 'B2C-Report', component: B2CReportComponent },

  //profit Billwise Profit
  { path: 'Sales_Vs_RM', component: SalesVsRMComponent },
  { path: 'itemwiseSales_Vs_RM', component: ItemwiseSalesVsRMComponent },
{ path: 'Billwise-Profit', component: BillwiseProfitComponent },
{ path: 'Itemwise-Profit', component: ItemwiseProfitComponent },
{ path: 'Customerwise-Profit', component: CustomerwiseProfitComponent },
{ path: 'Over-all', component: OverAllProfitComponent },
{ path: 'Sales-profit', component: SaleswiseProfitComponent },

  
  { path: '', component: LoginComponent },
  
  {
    path: 'dashboard', component: DashboardComponent,
    children: [
      { path: 'analytics', data: { breadcrumb: 'Analytics' }, component: AnalyticsComponent },
      { path: 'e-commerce', data: { breadcrumb: 'eCommerce' }, component: EcommerceComponent },
    ]
  },




  {
    path: 'authentication', component: AuthenticationComponent,
    children: [
      { path: 'login', pathMatch: 'full', data: { breadcrumb: 'Login' }, component: LoginComponent },
      { path: 'register', data: { breadcrumb: 'Register' }, component: RegisterComponent },
      { path: 'forgot-password', data: { breadcrumb: 'Forgot Password' }, component: ForgotPasswordComponent },
      { path: 'reset-password', data: { breadcrumb: 'Reset Password' }, component: ResetPasswordComponent },
    ]
  },


  { path: 'transaction', loadChildren: () => import('./transaction/transaction.module').then(m => m.TransactionModule) },

  { path: 'report', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },

  { path: 'sales', loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule) },

  { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule) },

  { path: 'Purchase', loadChildren: () => import('./purchase/purchase.module').then(m => m.PurchaseModule) },

  { path: 'master', loadChildren: () => import('./master/master.module').then(m => m.MasterModule) },

  { path: 'hotel', loadChildren: () => import('./hotel/hotel.module').then(m => m.HotelModule) },



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
